import React, { useEffect, useState } from "react";
import {
    IonModal,
    IonHeader,
    IonToolbar,
    IonTitle,
    IonContent,
    IonItem,
    IonLabel,
    IonDatetime,
    IonButton,
    IonSelect,
    IonSelectOption,
    IonInput,
    IonList,
    IonCard,
    IonCardHeader,
    IonCardTitle,
    IonCardContent,
    IonFooter,
    IonDatetimeButton,
    IonPage,
    IonIcon,
    IonText,
    IonAlert,
    IonButtons
} from "@ionic/react";
import { faPallet, faStore, faTrailer, faTruckLoading } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { trashBin } from "ionicons/icons";
import { Api } from "../services/api";
import moment from "moment";

interface AddDockingProps {
    api: Api;
    onDismiss: () => void; // close modal
    onSubmit: (data: any) => void; // call API in rosterDetail
    dock: any | null;
    onDelete: (id: number) => void;
    deletePalletEntry: (id: number) => void;
}

const AddDockingComponent: React.FC<AddDockingProps> = ({ onDismiss, onSubmit, api, dock, onDelete, deletePalletEntry }) => {


    const [isAlertOpen, setIsAlertOpen] = useState(false);

    const [dockingStart, setDockingStart] = useState<string | any>('');
    const [inDockStartTime, setInDockStartTime] = useState<string | any>('');

    const [dockingEnd, setDockingEnd] = useState<string | any>('');;
    const [store, setStore] = useState("");
    const [pallets, setPallets] = useState<any[]>([]);

    const minuteValuesInterval = "0,5,10,15,20,25,30,35,40,45,50,50,55";
    const storeOptions = api?.rosters?.rosterDetail?.timesheet_template?.selected_stores ? JSON.parse(api?.rosters?.rosterDetail?.timesheet_template?.selected_stores) : [];
    useEffect(() => {
        if (dock) {
            setStore(JSON.stringify(dock.store_id));
        }
    }, [dock, api.rosters?.rosterDetail]);

    const addPallet = () => {
        if (!store) return; // ensure store selected first
        setPallets([...pallets, { pallet_id: "", dropped: '', picked: '' }]);
    };

    const updatePallet = (index: number, field: string, value: any) => {
        setPallets(
            pallets.map((pallet, i) =>
                i === index ? { ...pallet, [field]: value } : pallet
            )
        );
    };

    const handleSubmit = () => {

        if (!store) {
            alert("Please select a store before submitting.");
            return;
        }

        //add zero to pallet dropped/picked if empty
        const updatedPallets = pallets.map((pallet) => ({
            ...pallet,
            dropped: pallet.dropped === '' ? 0 : pallet.dropped,
            picked: pallet.picked === '' ? 0 : pallet.picked,
        }));

        const payload = {
            id: dock?.id,
            store_id: store,
            pallets: updatedPallets,
        };
        console.log(payload);
        onSubmit(payload); // send back to rosterDetail page
        setPallets([]);
        // onDismiss();
    };

    const handleDockArrive = async ()  => {
        if (!store) {
            alert("Please select a store before submitting.");
            return;
        }
        const payload = {
            dock_type: 'dock-arrival',
            store_id: store,
            timesheet_entry_id: api?.rosters?.rosterDetail?.timesheet_entries[0]?.id
        };
        onSubmit(payload);
        // onDismiss();
    };

    const handleOnDockStart = () => {
        const payload = {
            dock_type: 'in-dock',
            id: dock.id
        };
        onSubmit(payload);
        // onDismiss();
    };

    const handleDockDeparture = () => {
        const payload = {
            dock_type: 'dock-departure',
            id: dock.id
        };
        onSubmit(payload);
        onDismiss();
    };

    const removePallet = (index: number) => {
        setPallets(pallets.filter((_, i) => i !== index));
    };

    const handleDelete = () => {
        onDelete(dock.id);
        onDismiss();
    };

    const handleDeletePalletEntry = (palletId: number) => {
        deletePalletEntry(palletId);
        // onDismiss();
    };
    
    return (
        <IonPage >
            <IonHeader>
                <IonToolbar>
                    <IonButtons slot="start">
                        <IonButton color="medium" onClick={() => onDismiss()}>
                            Cancel
                        </IonButton>
                    </IonButtons>
                    <IonTitle>Add Docking</IonTitle>
                </IonToolbar>
            </IonHeader>


            <IonContent className="ion-padding">

                <IonItem>
                    <IonLabel>Store</IonLabel>
                    <IonSelect
                        placeholder="Select Store"
                        value={store}
                        onIonChange={(e) => setStore(e.detail.value)}
                    >
                        {storeOptions.map((option: any) => (
                            <IonSelectOption key={option.id} value={option.id}>
                                {option.name}
                            </IonSelectOption>
                        ))}
                    </IonSelect>
                </IonItem>

                <IonList>
                    <IonItem>
                        <IonLabel>Dock Arrival</IonLabel>
                        {/* <IonDatetimeButton datetime="datetime"></IonDatetimeButton>
                        <IonModal keepContentsMounted={true}>
                            <IonDatetime id="datetime" disabled={!store} minuteValues={minuteValuesInterval} presentation="time" onIonChange={(e) => setDockingStart(e.detail.value!)}></IonDatetime>
                        </IonModal> */}
                        {dock?.arrival_time ? (
                            <IonText>{moment(dock.arrival_time).format("HH:mm")}</IonText>
                        ) : (
                            <IonButton
                                color="success"
                                expand="full"
                                size="large"
                                shape="round"
                                disabled={!store}
                                onClick={() => {
                                    handleDockArrive();
                                }}
                                style={{
                                    width: 100,
                                    height: 100,
                                    fontSize: '20px',
                                    fontWeight: 'bold',
                                    textAlign: 'center',
                                    "--border-radius": '50%',
                                    '--ripple-color': 'red',
                                }}
                            >
                                Arrive
                            </IonButton>
                        )}
                    </IonItem>
                    {dock?.arrival_time && <IonItem>
                        <IonLabel>Dock In Time</IonLabel>
                        {/* <IonDatetimeButton datetime="datetime3"></IonDatetimeButton>
                        <IonModal keepContentsMounted={true}>
                            <IonDatetime id="datetime3" disabled={!store} minuteValues={minuteValuesInterval} presentation="time" onIonChange={(e) => setInDockStartTime(e.detail.value!)}></IonDatetime>
                        </IonModal> */}
                        {dock?.on_dock_time ? (
                            <IonText>{moment(dock.on_dock_time).format("HH:mm")}</IonText>
                        ) : (
                            <IonButton
                                color="success"
                                expand="full"
                                size="large"
                                shape="round"
                                disabled={!store}
                                style={{
                                    width: 100,
                                    height: 100,
                                    fontSize: '20px',
                                    fontWeight: 'bold',
                                    textAlign: 'center',
                                    "--border-radius": '50%',
                                    '--ripple-color': 'red',
                                }}
                                onClick={() => {
                                    handleOnDockStart();
                                }}
                            >
                                Set
                            </IonButton>)}
                    </IonItem>}
                    {dock?.on_dock_time && <IonItem>
                        <IonLabel>Dock Departure</IonLabel>
                        {/* <IonDatetimeButton datetime="datetime2"></IonDatetimeButton>
                        <IonModal keepContentsMounted={true}>
                            <IonDatetime id="datetime2" disabled={!store} minuteValues={minuteValuesInterval} presentation="time" onIonChange={(e) => setDockingEnd(e.detail.value!)}></IonDatetime>
                        </IonModal> */}
                        {dock?.depart_time ? (
                            <IonText>{moment(dock.depart_time).format("HH:mm")}</IonText>
                        ) : (
                            <IonButton
                                color="success"
                                disabled={!store}
                                expand="full"
                                size="large"
                                shape="round"
                                style={{
                                    width: 100,
                                    height: 100,
                                    fontSize: '20px',
                                    fontWeight: 'bold',
                                    textAlign: 'center',
                                    "--border-radius": '50%',
                                    '--ripple-color': 'red',
                                }}
                                onClick={() => {
                                    handleDockDeparture();
                                }}
                            >
                                Depart
                            </IonButton>)}
                    </IonItem>}
                </IonList>
                {dock?.stores_pallets && (
                    <>
                        {dock.stores_pallets.map((storePallet: any, idx: number) => (
                            <IonCard className="ion-margin">
                                <IonCardContent className="p-0">
                                    <table className="table ion-text-center mb-0" style={{ fontSize: 14 }} >
                                        <thead>
                                            <tr>
                                                <th>Pallet</th>
                                                <th>Dropped</th>
                                                <th>Picked</th>
                                                {!dock?.depart_time && <th>Action</th>}
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>{storePallet.pallet ? storePallet.pallet.title : 'N/A'}</td>
                                                <td>{storePallet.qty_dropped ? storePallet.qty_dropped : 'N/A'}</td>
                                                <td>{storePallet.qty_picked ? storePallet.qty_picked : 'N/A'}</td>
                                               {!dock?.depart_time && <td>
                                                     <IonButton
                                                        color="danger"
                                                        size="small"
                                                        onClick={() => { handleDeletePalletEntry(storePallet.id) }}
                                                    >
                                                        <IonIcon icon={trashBin} size="small" />
                                                    </IonButton>
                                                </td>}
                                            </tr>
                                        </tbody>
                                    </table>
                                </IonCardContent>
                            </IonCard>
                        ))}
                    </>
                )}
                {pallets.map((pallet, idx) => (
                    <IonCard key={idx} className="ion-margin">
                        <IonCardHeader>
                            <div className="d-flex justify-content-between align-items-center">
                                <h4>Add Pallet</h4>
                                <IonButton
                                    expand="block"
                                    color="light"
                                    size="small"
                                    onClick={() => removePallet(idx)}
                                >
                                    <IonIcon slot="icon-only" size="small" icon={trashBin} />
                                </IonButton>
                            </div>
                        </IonCardHeader>
                        <IonCardContent>
                            <IonItem>
                                <IonLabel>Pallet Type</IonLabel>
                                <IonSelect
                                    value={pallet.pallet_id}
                                    placeholder="Select Type"
                                    onIonChange={(e) => updatePallet(idx, "pallet_id", e.detail.value)}
                                >
                                    {api.rosters?.resources?.pallets.map((option: any) => (
                                        <IonSelectOption key={option.id} value={option.id}>
                                            {option.title}
                                        </IonSelectOption>
                                    ))}
                                </IonSelect>
                            </IonItem>

                            <IonItem>
                                <IonLabel position="stacked">Pallet Dropped</IonLabel>
                                <IonInput
                                    type="number"
                                    placeholder="Enter number of pallets dropped"
                                    disabled={!pallet.pallet_id}
                                    value={pallet.dropped}
                                    onIonInput={(e) => updatePallet(idx, "dropped", e.detail.value)}
                                />
                            </IonItem>

                            <IonItem>
                                <IonLabel position="stacked">Pallet Picked</IonLabel>
                                <IonInput
                                    type="number"
                                    placeholder="Enter number of pallets picked"
                                    value={pallet.picked}
                                    disabled={!pallet.pallet_id}
                                    onIonInput={(e) => updatePallet(idx, "picked", e.detail.value)}
                                />
                            </IonItem>
                            {!dock?.depart_time &&
                                <>
                                    <IonButton expand="block" color="success" onClick={handleSubmit}>
                                        Submit
                                    </IonButton>

                                </>
                            }
                        </IonCardContent>
                    </IonCard>
                ))}


                {!dock?.depart_time && dock?.on_dock_time && <IonButton
                    className="m-3"
                    expand="block"
                    color="dark"
                    disabled={!store}
                    onClick={() => addPallet()}
                >
                    + Add Pallet
                </IonButton>}
            </IonContent >
            <IonFooter className="ion-padding">
                {/* hide the button for now */}
                {dock?.id && false && <IonButton
                    expand="block"
                    color="danger"
                    onClick={() => { setIsAlertOpen(true) }}
                >
                    <IonIcon slot="icon-only" size="small" icon={trashBin} />
                </IonButton>}
                <IonButton expand="block" fill="outline" onClick={onDismiss}>
                    Cancel
                </IonButton>
            </IonFooter>
            <IonAlert
                header="Confirmation"
                subHeader="Are you sure you want to delete the docking?"
                trigger="submit-alert"
                isOpen={isAlertOpen}
                buttons={[
                    {
                        text: 'Cancel',
                        role: 'cancel',
                        handler: () => {
                        },
                    },
                    {
                        text: 'Confirm',
                        role: 'confirm',
                        handler: (e) => {
                            handleDelete();
                        },
                    },
                ]}
                onDidDismiss={() => setIsAlertOpen(false)}
            ></IonAlert>
        </IonPage >
    );
};

export default AddDockingComponent;
